var _Glyphicon;
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

// reaxl
import { AccordionPanel, Button, Glyphicon, Select, MultiSelectDropdown } from 'reaxl';
import { formatNumber } from '@atc/string-fns';

// reaxl-filter
import FilterTitle from '../FilterTitle';
import FilterCheckboxLabel from '../FilterCheckboxLabel';
import FilterCheckboxesExpansion from '../FilterCheckboxesExpansion';

/**
 *  Filter By MakeModelTrim combo renders a group of select elements and custom styling
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterMakeModelTrim(_ref) {
  let {
    collapsed,
    collapsedTitle,
    filter,
    filters,
    filtersOrder,
    hideOptionCounts,
    onOptionChange,
    onOptionsClear,
    resultCount,
    values,
    groupsLimit = 5,
    ...rest
  } = _ref;
  const {
    makeFilterOptions = {},
    modelFilterOptions = {},
    seriesFilterOptions = {},
    trimFilterOptions = {},
    packageOptions = {},
    handleRemoveMake = () => {}
  } = filter;
  const makeCodeKey = makeFilterOptions.key;
  const modelCodeKey = modelFilterOptions.key;
  const seriesCodeKey = seriesFilterOptions.key;
  const trimCodeKey = trimFilterOptions.key;
  const packageKey = packageOptions.key;
  const [showNewGroup, setShowNewGroup] = useState(false);
  useEffect(() => {
    if (values?.[makeCodeKey]) {
      setShowNewGroup(false);
    } else {
      setShowNewGroup(true);
    }
  }, [values?.[makeCodeKey], setShowNewGroup, makeCodeKey, values]);
  const title = /*#__PURE__*/_jsx(FilterTitle, {
    title: filter.label
  }, "filterTitleKey");
  const getFilterOptions = (options, label) => {
    if (hideOptionCounts) {
      return options;
    }
    const selectOptions = [];
    selectOptions.push({
      label,
      value: label,
      hidden: true
    });
    const optionCount = option => {
      if (option.count) {
        return `(${formatNumber({
          value: option.count
        })})`;
      }
      if (option.disabled) {
        return '(0)';
      }
      return '';
    };
    options?.map(option => !makeFilterOptions?.value?.includes(option.value) && selectOptions.push({
      ...option,
      label: `${option.label} ${optionCount(option)}`
    }));
    return selectOptions;
  };
  const handleButtonClick = () => {
    setShowNewGroup(true);
  };
  const handleRemoveClick = useCallback(value => {
    const payload = {
      filter: {
        name: makeCodeKey,
        value,
        isMultiple: true
      },
      value,
      isMultiple: true
    };
    handleRemoveMake(payload);
  }, [handleRemoveMake, makeCodeKey]);
  const renderGroup = (makeCode, index) => {
    const models = modelFilterOptions[`${modelCodeKey}|${makeCode}`];
    const series = seriesFilterOptions[`${seriesCodeKey}|${makeCode}`];
    const updateOptionLabels = options => options && options.map(option => ({
      ...option,
      label: /*#__PURE__*/_jsx(FilterCheckboxLabel, {
        label: option.label,
        count: option.count,
        moreInfo: option.moreInfo,
        filterBadge: option.filterBadge,
        "aria-label": option.label
      })
    }));
    const {
      label
    } = makeFilterOptions?.options?.find(option => option.value === makeCode) || {};
    return /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsxs("div", {
        className: "col-xs-12 padding-bottom-3",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "text-size-200 text-subdued-lighter margin-bottom-1 text-bold",
          children: [label ? `${label}` : `Vehicle ${index + 1}`, label && /*#__PURE__*/_jsx(Button, {
            className: "pull-right",
            bsStyle: "text",
            onClick: () => handleRemoveClick(makeCode),
            "aria-label": "Remove",
            children: _Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
              glyph: "remove",
              className: "text-gray"
            }))
          })]
        }), !label && /*#__PURE__*/_jsx(Select, {
          onChange: event => onOptionChange(event, makeFilterOptions),
          options: getFilterOptions(makeFilterOptions?.options, 'Any Make'),
          name: makeFilterOptions.name,
          value: makeCode || ''
        }), series && /*#__PURE__*/_jsx(MultiSelectDropdown, {
          onChange: event => onOptionChange(event, series),
          options: updateOptionLabels(series?.options),
          name: series?.name,
          defaultSelectLabel: "Any",
          affixLabel: "Series",
          uiContext: "filters"
        }), label && /*#__PURE__*/_jsx(MultiSelectDropdown, {
          onChange: event => onOptionChange(event, models),
          disabled: !models?.options,
          options: updateOptionLabels(models?.options),
          name: models?.name,
          defaultSelectLabel: "Any",
          affixLabel: "Models",
          uiContext: "filters"
        }), values[`${modelCodeKey}|${makeCode}`]?.map((model, modelIndex) => {
          const trim = trimFilterOptions[`${trimCodeKey}|${model}`];
          return trim && /*#__PURE__*/_jsx(MultiSelectDropdown, {
            onChange: event => onOptionChange(event, trim),
            options: updateOptionLabels(trim?.options),
            name: trim?.name,
            defaultSelectLabel: "Any",
            affixLabel: `${trim?.label}s`,
            uiContext: "filters"
          }, `${model}-trim-${modelIndex}`);
        }), label && models?.extendedOption && /*#__PURE__*/_jsx(Button, {
          bsStyle: "text",
          "data-cmp": "cntnr-extnd-opt",
          onClick: event => {
            models?.onExtendedOptionsClick(event, models);
          },
          children: models?.extendedOption
        }), values[`${modelCodeKey}|${makeCode}`]?.map(model => values[`${trimCodeKey}|${model}`]?.map((trim, trimIndex) => {
          const packageOpts = packageOptions[`${packageKey}|${trim}`];
          return packageOpts && /*#__PURE__*/_jsx(MultiSelectDropdown, {
            onChange: event => onOptionChange(event, packageOpts),
            options: updateOptionLabels(packageOpts?.options),
            name: packageOpts?.name,
            defaultSelectLabel: "Any",
            affixLabel: `${packageOpts?.label}`,
            uiContext: "filters"
          }, `${model}-trim-${trimIndex}`);
        }))]
      })
    }, `${makeCode}-${index}`);
  };

  // Troubleshooting t.map TypeError issue
  if (values?.[makeCodeKey] && !Array.isArray(values?.[makeCodeKey])) {
    if (typeof window !== 'undefined' && window.newrelic) {
      window.newrelic.addPageAction('FilterAction', {
        makeCodeKey,
        component: 'FilterMakeModelTrim',
        makes: values?.[makeCodeKey],
        typeof: typeof values?.[makeCodeKey],
        message: `Value for ${makeCodeKey} is not an array`
      });
    } else {
      // eslint-disable-next-line no-console
      console.error(`Value for ${makeCodeKey} is not an array. value: ${values?.[makeCodeKey]} | type: ${typeof values?.[makeCodeKey]}`);
    }
  }
  let makeCodeValues = values?.[makeCodeKey];
  if (typeof makeCodeValues === 'string') {
    makeCodeValues = values?.[makeCodeKey].split(' ');
  }
  return /*#__PURE__*/_jsxs(AccordionPanel, {
    "data-cmp": "filterSelect",
    eventKey: filter.name,
    title: title,
    ...rest,
    children: [makeCodeValues?.map((makeCode, index) => renderGroup(makeCode, index)), showNewGroup && renderGroup(null, makeCodeValues?.length || 0), makeCodeValues?.length < groupsLimit && !showNewGroup && /*#__PURE__*/_jsx(Button, {
      block: true,
      onClick: handleButtonClick,
      children: "Add Another Make"
    })]
  });
}
FilterCheckboxesExpansion.propTypes = {
  /**
   * The node after the last dropdown in each make section
   */
  extendedOption: PropTypes.node,
  /**
   * Callback function fired on extendedOption node
   */
  onExtendedOptionsClick: PropTypes.func
};
export default FilterMakeModelTrim;